import lenis from '../../js/scroll.js';

const scrollTopSelector = '[data-scroll-top]';

function initScrollTop() {
  const buttons = document.querySelectorAll(scrollTopSelector);

  buttons.forEach(button => {
    button.addEventListener('click', () => {
      lenis.scrollTo(0);
    });
  });
}

initScrollTop();
